import { useNotifier } from '../../../../components/notifier';
import { NotifierMessageSeverityType } from '../../../../components/notifier/interfaces';

export function useNudgeNotifier() {
  const { dispatch } = useNotifier();

  function notify(message: string, severity: NotifierMessageSeverityType) {
    dispatch({ type: 'notify', payload: { message, severity } });
  }

  function notifyLoadError(error: unknown, fallbackMessage: string) {
    const bffError = (error as { response?: { data?: object } })?.response?.data;
    const payload = bffError ? { ...bffError, hideExtraInfo: true } : { message: fallbackMessage, severity: 'error' };
    dispatch({ type: 'notify', payload });
  }

  return { notify, notifyLoadError };
}
